(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["block-carusel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('icr-carousel')) {
    class IcrCarousel extends HTMLElement {
      connectedCallback() {
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', () => this.init(), { once: true });
        } else {
          this.init();
        }
      }

      init() {
        if (this.ready) return;
        this.ready = true;
        this.reveal();
        this.track = this.querySelector('.icr__track');
        if (!this.track) return;
        this.prev = this.querySelector('[data-icr-prev]');
        this.next = this.querySelector('[data-icr-next]');
        this.update = this.update.bind(this);
        this.track.addEventListener('scroll', this.update, { passive: true });
        if (this.prev) this.prev.addEventListener('click', () => this.move(-1));
        if (this.next) this.next.addEventListener('click', () => this.move(1));
        this.observer = new ResizeObserver(this.update);
        this.observer.observe(this.track);
        this.update();
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        if (this.revealer) this.revealer.disconnect();
      }

      reveal() {
        const items = this.querySelectorAll('[data-reveal]');
        if (!items.length) return;
        const stagger = parseInt(this.dataset.stagger, 10) || 0;
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (reduced || !('IntersectionObserver' in window)) {
          items.forEach((item) => item.classList.add('is-visible'));
          return;
        }
        this.revealer = new IntersectionObserver((entries, observer) => {
          let order = 0;
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.style.transitionDelay = order * stagger + 'ms';
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
            order += 1;
          });
        }, { threshold: 0.15 });
        items.forEach((item) => this.revealer.observe(item));
      }

      move(direction) {
        const slide = this.track.querySelector('.icr__slide');
        if (!slide) return;
        const style = getComputedStyle(this.track);
        const gap = parseFloat(style.columnGap) || 0;
        const rtl = style.direction === 'rtl' ? -1 : 1;
        this.track.scrollBy({
          left: direction * rtl * (slide.getBoundingClientRect().width + gap),
          behavior: 'smooth'
        });
      }

      update() {
        const track = this.track;
        const max = track.scrollWidth - track.clientWidth;
        const position = Math.abs(track.scrollLeft);
        this.toggleAttribute('data-static', max <= 2);
        if (this.prev) this.prev.disabled = position <= 2;
        if (this.next) this.next.disabled = position >= max - 2;
      }
    }

    customElements.define('icr-carousel', IcrCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brand-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('brc-carousel')) {
    class BrcCarousel extends HTMLElement {
      connectedCallback() {
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', () => this.init(), { once: true });
        } else {
          this.init();
        }
      }

      disconnectedCallback() {
        clearInterval(this.timer);
        clearTimeout(this.touchTimer);
        if (this.sync) document.removeEventListener('visibilitychange', this.sync);
        if (this.resizer) this.resizer.disconnect();
        if (this.viewer) this.viewer.disconnect();
        if (this.revealer) this.revealer.disconnect();
      }

      init() {
        if (this.ready) return;
        this.ready = true;
        this.reveal();
        this.track = this.querySelector('.brc__track');
        if (!this.track) return;

        this.prev = this.querySelector('[data-brc-prev]');
        this.next = this.querySelector('[data-brc-next]');
        this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.autoplay = this.dataset.autoplay === 'true' && !this.reduced;
        this.interval = (parseInt(this.dataset.interval, 10) || 3) * 1000;
        this.pauseOnHover = this.dataset.pause === 'true';
        this.state = { hover: false, focus: false, touch: false, visible: true };
        this.isStatic = false;
        this.sync = this.sync.bind(this);

        if (this.prev) this.prev.addEventListener('click', () => this.go(-1));
        if (this.next) this.next.addEventListener('click', () => this.go(1));

        this.addEventListener('pointerenter', (event) => {
          if (event.pointerType !== 'mouse') return;
          this.state.hover = true;
          this.sync();
        });
        this.addEventListener('pointerleave', (event) => {
          if (event.pointerType !== 'mouse') return;
          this.state.hover = false;
          this.sync();
        });
        this.addEventListener('focusin', (event) => {
          if (!event.target.matches(':focus-visible')) return;
          this.state.focus = true;
          this.sync();
        });
        this.addEventListener('focusout', (event) => {
          if (this.contains(event.relatedTarget)) return;
          this.state.focus = false;
          this.sync();
        });
        this.addEventListener('touchstart', () => {
          clearTimeout(this.touchTimer);
          this.state.touch = true;
          this.sync();
        }, { passive: true });
        this.addEventListener('touchend', () => {
          clearTimeout(this.touchTimer);
          this.touchTimer = setTimeout(() => {
            this.state.touch = false;
            this.sync();
          }, this.interval);
        }, { passive: true });

        document.addEventListener('visibilitychange', this.sync);

        this.viewer = new IntersectionObserver((entries) => {
          this.state.visible = entries[0].isIntersecting;
          this.sync();
        });
        this.viewer.observe(this);

        this.resizer = new ResizeObserver(() => this.measure());
        this.resizer.observe(this.track);
        this.measure();
      }

      measure() {
        const track = this.track;
        this.isStatic = track.scrollWidth - track.clientWidth <= 2;
        this.toggleAttribute('data-static', this.isStatic);
        this.sync();
      }

      sync() {
        clearInterval(this.timer);
        this.timer = null;
        const state = this.state;
        const paused = this.pauseOnHover && (state.hover || state.focus);
        const run = this.autoplay && !this.isStatic && state.visible && !state.touch && !document.hidden && !paused;
        if (run) this.timer = setInterval(() => this.move(1), this.interval);
      }

      go(direction) {
        this.move(direction);
        this.sync();
      }

      move(direction) {
        const track = this.track;
        const slide = track.querySelector('.brc__slide');
        if (!slide) return;
        const style = getComputedStyle(track);
        const gap = parseFloat(style.columnGap) || 0;
        const unit = slide.getBoundingClientRect().width + gap;
        const count = this.dataset.step === 'page' ? Math.max(1, Math.floor((track.clientWidth + gap) / unit)) : 1;
        const rtl = style.direction === 'rtl' ? -1 : 1;
        const max = track.scrollWidth - track.clientWidth;
        const position = Math.abs(track.scrollLeft);
        const behavior = this.reduced ? 'auto' : 'smooth';
        if (direction > 0 && position >= max - 2) {
          track.scrollTo({ left: 0, behavior });
        } else if (direction < 0 && position <= 2) {
          track.scrollTo({ left: max * rtl, behavior });
        } else {
          track.scrollBy({ left: direction * rtl * unit * count, behavior });
        }
      }

      reveal() {
        const items = this.querySelectorAll('[data-reveal]');
        if (!items.length) return;
        const stagger = parseInt(this.dataset.stagger, 10) || 0;
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (reduced || !('IntersectionObserver' in window)) {
          items.forEach((item) => item.classList.add('is-visible'));
          return;
        }
        this.revealer = new IntersectionObserver((entries, observer) => {
          let order = 0;
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.style.setProperty('--d', order * stagger + 'ms');
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
            order += 1;
          });
        }, { threshold: 0.15 });
        items.forEach((item) => this.revealer.observe(item));
      }
    }

    customElements.define('brc-carousel', BrcCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cetagory-tabs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tbs-tabs')) {
    class TbsTabs extends HTMLElement {
      connectedCallback() {
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', () => this.init(), { once: true });
        } else {
          this.init();
        }
      }

      disconnectedCallback() {
        clearTimeout(this.swapTimer);
        if (this.revealer) this.revealer.disconnect();
        if (this.resizers) this.resizers.forEach((resizer) => resizer.disconnect());
      }

      init() {
        if (this.ready) return;
        this.ready = true;
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
        this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.mode = this.dataset.tabAnim;
        this.duration = parseInt(this.dataset.tabDuration, 10) || 0;
        this.current = Math.max(0, this.panels.findIndex((panel) => !panel.hidden));
        this.resizers = [];

        this.panels.forEach((panel) => this.setupPanel(panel));

        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => this.activate(index, false));
          tab.addEventListener('keydown', (event) => this.onKey(event, index));
        });

        this.addEventListener('shopify:block:select', (event) => {
          const tab = event.target.closest('[role="tab"]');
          const panel = event.target.closest('[role="tabpanel"]');
          if (tab) this.activate(this.tabs.indexOf(tab), false);
          else if (panel) this.activate(this.panels.indexOf(panel), false);
        });

        this.reveal();
      }

      onKey(event, index) {
        const rtl = getComputedStyle(this).direction === 'rtl' ? -1 : 1;
        const last = this.tabs.length - 1;
        let target = null;
        if (event.key === 'ArrowRight') target = index + rtl;
        else if (event.key === 'ArrowLeft') target = index - rtl;
        else if (event.key === 'Home') target = 0;
        else if (event.key === 'End') target = last;
        if (target === null) return;
        event.preventDefault();
        this.activate(Math.min(last, Math.max(0, target)), true);
      }

      activate(index, focus) {
        if (index < 0 || index >= this.panels.length) return;
        this.tabs.forEach((tab, position) => {
          const active = position === index;
          tab.classList.toggle('is-active', active);
          tab.setAttribute('aria-selected', active ? 'true' : 'false');
          tab.tabIndex = active ? 0 : -1;
        });
        if (focus && this.tabs[index]) this.tabs[index].focus();
        if (index === this.current) return;
        const previous = this.panels[this.current];
        this.current = index;
        this.swap(previous, this.panels[index]);
      }

      swap(previous, next) {
        clearTimeout(this.swapTimer);
        this.panels.forEach((panel) => {
          if (panel !== previous && panel !== next) {
            panel.hidden = true;
            panel.classList.remove('is-leaving', 'is-entering');
          }
        });
        next.classList.remove('is-leaving');
        if (this.mode === 'none' || this.reduced) {
          previous.hidden = true;
          previous.classList.remove('is-leaving');
          next.hidden = false;
          return;
        }
        next.classList.add('is-entering');
        next.hidden = false;
        previous.classList.add('is-leaving');
        void next.offsetWidth;
        next.classList.remove('is-entering');
        this.swapTimer = setTimeout(() => {
          previous.hidden = true;
          previous.classList.remove('is-leaving');
        }, this.duration);
      }

      setupPanel(panel) {
        const track = panel.querySelector('.tbs__track');
        if (!track) return;
        const prev = panel.querySelector('[data-tbs-prev]');
        const next = panel.querySelector('[data-tbs-next]');

        const update = () => {
          const max = track.scrollWidth - track.clientWidth;
          const position = Math.abs(track.scrollLeft);
          panel.toggleAttribute('data-static', max <= 2);
          if (prev) prev.disabled = position <= 2;
          if (next) next.disabled = position >= max - 2;
        };

        const move = (direction) => {
          const slide = track.querySelector('.tbs__slide');
          if (!slide) return;
          const style = getComputedStyle(track);
          const gap = parseFloat(style.columnGap) || 0;
          const rtl = style.direction === 'rtl' ? -1 : 1;
          track.scrollBy({
            left: direction * rtl * (slide.getBoundingClientRect().width + gap),
            behavior: this.reduced ? 'auto' : 'smooth'
          });
        };

        track.addEventListener('scroll', update, { passive: true });
        if (prev) prev.addEventListener('click', () => move(-1));
        if (next) next.addEventListener('click', () => move(1));

        const resizer = new ResizeObserver(update);
        resizer.observe(track);
        this.resizers.push(resizer);
        update();
      }

      reveal() {
        const items = this.querySelectorAll('[data-reveal]');
        if (!items.length) return;
        const stagger = parseInt(this.dataset.stagger, 10) || 0;
        if (this.reduced || !('IntersectionObserver' in window)) {
          items.forEach((item) => item.classList.add('is-visible'));
          return;
        }
        this.revealer = new IntersectionObserver((entries, observer) => {
          let order = 0;
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.style.setProperty('--d', order * stagger + 'ms');
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
            order += 1;
          });
        }, { threshold: 0.15 });
        items.forEach((item) => this.revealer.observe(item));
      }
    }

    customElements.define('tbs-tabs', TbsTabs);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["client-marquee"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mrq-marquee')) {
    class MrqMarquee extends HTMLElement {
      connectedCallback() {
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', () => this.init(), { once: true });
        } else {
          this.init();
        }
      }

      disconnectedCallback() {
        clearInterval(this.timer);
        clearTimeout(this.touchTimer);
        if (this.sync) document.removeEventListener('visibilitychange', this.sync);
        if (this.resizer) this.resizer.disconnect();
        if (this.viewer) this.viewer.disconnect();
        if (this.revealer) this.revealer.disconnect();
      }

      init() {
        if (this.ready) return;
        this.ready = true;
        this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.reveal();
        this.track = this.querySelector('.mrq__track');
        this.port = this.querySelector('.mrq__viewport');
        if (!this.track || !this.port) return;

        this.count = parseInt(this.dataset.count, 10) || 0;
        this.mode = this.dataset.mode;
        this.direction = this.dataset.dir === 'right' ? -1 : 1;
        this.speed = parseFloat(this.dataset.speed) || 40;
        this.stepDuration = parseInt(this.dataset.stepDuration, 10) || 600;
        this.interval = Math.max((parseInt(this.dataset.interval, 10) || 3) * 1000, this.stepDuration + 100);
        this.pauseOnHover = this.dataset.pause === 'true';
        this.state = { hover: false, focus: false, touch: false, visible: true };
        this.isStatic = false;
        this.index = this.direction > 0 ? 0 : this.count;
        this.sync = this.sync.bind(this);

        if (this.mode === 'step' && !this.reduced) {
          this.place(this.index);
          this.track.addEventListener('transitionend', (event) => {
            if (event.target !== this.track || event.propertyName !== 'transform') return;
            this.settle();
          });
        }

        this.addEventListener('pointerenter', (event) => {
          if (event.pointerType !== 'mouse') return;
          this.state.hover = true;
          this.sync();
        });
        this.addEventListener('pointerleave', (event) => {
          if (event.pointerType !== 'mouse') return;
          this.state.hover = false;
          this.sync();
        });
        this.addEventListener('focusin', (event) => {
          if (!event.target.matches(':focus-visible')) return;
          this.state.focus = true;
          this.sync();
        });
        this.addEventListener('focusout', (event) => {
          if (this.contains(event.relatedTarget)) return;
          this.state.focus = false;
          this.sync();
        });
        this.addEventListener('touchstart', () => {
          clearTimeout(this.touchTimer);
          this.state.touch = true;
          this.sync();
        }, { passive: true });
        this.addEventListener('touchend', () => {
          clearTimeout(this.touchTimer);
          this.touchTimer = setTimeout(() => {
            this.state.touch = false;
            this.sync();
          }, 1500);
        }, { passive: true });

        document.addEventListener('visibilitychange', this.sync);

        this.viewer = new IntersectionObserver((entries) => {
          this.state.visible = entries[0].isIntersecting;
          this.sync();
        });
        this.viewer.observe(this);

        this.resizer = new ResizeObserver(() => this.measure());
        this.resizer.observe(this.port);
        this.measure();
      }

      measure() {
        const slide = this.track.querySelector('.mrq__slide');
        if (!slide || !this.count) return;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        const unit = slide.getBoundingClientRect().width + gap;
        if (!unit) return;
        const visible = Math.floor((this.port.clientWidth + gap + 2) / unit);
        this.isStatic = this.count <= visible;
        this.toggleAttribute('data-static', this.isStatic);
        if (this.mode === 'continuous') {
          this.track.style.setProperty('--dur', (unit * this.count) / this.speed + 's');
        }
        this.sync();
      }

      sync() {
        clearInterval(this.timer);
        this.timer = null;
        const state = this.state;
        const paused = this.pauseOnHover && (state.hover || state.focus);
        const run = !this.reduced && !this.isStatic && state.visible && !state.touch && !document.hidden && !paused;
        if (this.mode === 'continuous') {
          this.toggleAttribute('data-paused', !run);
        } else if (run) {
          this.timer = setInterval(() => this.step(), this.interval);
        }
      }

      step() {
        this.index += this.direction;
        this.track.style.setProperty('--i', this.index);
      }

      settle() {
        const done = this.direction > 0 ? this.index >= this.count : this.index <= 0;
        if (!done) return;
        this.place(this.direction > 0 ? 0 : this.count);
      }

      place(index) {
        this.index = index;
        this.track.setAttribute('data-jump', '');
        this.track.style.setProperty('--i', index);
        void this.track.offsetWidth;
        this.track.removeAttribute('data-jump');
      }

      reveal() {
        const items = this.querySelectorAll('[data-reveal]');
        if (!items.length) return;
        const stagger = parseInt(this.dataset.stagger, 10) || 0;
        if (this.reduced || !('IntersectionObserver' in window)) {
          items.forEach((item) => item.classList.add('is-visible'));
          return;
        }
        this.revealer = new IntersectionObserver((entries, observer) => {
          let order = 0;
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.style.setProperty('--d', order * stagger + 'ms');
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
            order += 1;
          });
        }, { threshold: 0.15 });
        items.forEach((item) => this.revealer.observe(item));
      }
    }

    customElements.define('mrq-marquee', MrqMarquee);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["community-events"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cmn-community')) {
    class CmnCommunity extends HTMLElement {
      connectedCallback() {
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', () => this.init(), { once: true });
        } else {
          this.init();
        }
      }

      disconnectedCallback() {
        this.unlock();
        if (this.revealer) this.revealer.disconnect();
      }

      init() {
        if (this.ready) return;
        this.ready = true;
        this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.reveal();
        this.setupCover();
        this.setupModal();
      }

      setupCover() {
        const vimeo = this.querySelector('[data-vimeo]');
        if (vimeo) {
          const url = 'https://vimeo.com/' + vimeo.dataset.vimeo;
          fetch('https://vimeo.com/api/oembed.json?width=1280&url=' + encodeURIComponent(url))
            .then((response) => (response.ok ? response.json() : Promise.reject()))
            .then((data) => {
              if (data.thumbnail_url) this.setCover(vimeo, data.thumbnail_url);
            })
            .catch(() => {});
        }

        const youtube = this.querySelector('[data-fallback]');
        if (youtube) {
          const check = () => {
            if (!youtube.dataset.fallback || youtube.naturalWidth > 120) return;
            youtube.src = youtube.dataset.fallback;
            youtube.removeAttribute('data-fallback');
          };
          youtube.addEventListener('error', check);
          youtube.addEventListener('load', check);
          if (youtube.complete) check();
        }
      }

      setCover(frame, url) {
        const image = new Image();
        image.className = 'cmn__image';
        image.alt = '';
        image.addEventListener('load', () => {
          const placeholder = frame.querySelector('.cmn__placeholder');
          if (placeholder) placeholder.remove();
          frame.insertBefore(image, frame.firstChild);
        });
        image.src = url;
      }

      setupModal() {
        const dialog = this.querySelector('.cmn__dialog');
        const trigger = this.querySelector('[data-cmn-play]');
        if (!dialog || !trigger) return;
        const frame = dialog.querySelector('.cmn__iframe');
        const media = dialog.querySelector('.cmn__modal-video');
        const close = dialog.querySelector('[data-cmn-close]');

        trigger.addEventListener('click', () => {
          this.lock();
          dialog.showModal();
          if (frame) frame.src = frame.dataset.src;
          if (media) {
            const promise = media.play();
            if (promise && promise.catch) promise.catch(() => {});
          }
        });
        close.addEventListener('click', () => dialog.close());
        dialog.addEventListener('click', (event) => {
          if (event.target === dialog) dialog.close();
        });
        dialog.addEventListener('close', () => {
          if (frame) frame.removeAttribute('src');
          if (media) media.pause();
          this.unlock();
        });
      }

      lock() {
        const root = document.documentElement;
        const gap = window.innerWidth - root.clientWidth;
        root.style.setProperty('--cmn-sbw', gap + 'px');
        root.classList.add('cmn-locked');
      }

      unlock() {
        const root = document.documentElement;
        root.classList.remove('cmn-locked');
        root.style.removeProperty('--cmn-sbw');
      }

      reveal() {
        const items = this.querySelectorAll('[data-reveal]');
        if (!items.length) return;
        const stagger = parseInt(this.dataset.stagger, 10) || 0;
        if (this.reduced || !('IntersectionObserver' in window)) {
          items.forEach((item) => item.classList.add('is-visible'));
          return;
        }
        this.revealer = new IntersectionObserver((entries, observer) => {
          let order = 0;
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.style.setProperty('--d', order * stagger + 'ms');
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
            order += 1;
          });
        }, { threshold: 0.15 });
        items.forEach((item) => this.revealer.observe(item));
      }
    }

    customElements.define('cmn-community', CmnCommunity);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-us-form"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.addEventListener('submit', (e) => {
      const form = e.target;
      if (!form.matches || !form.matches('[data-cf-form]')) return;
      const btn = form.querySelector('.cf__button');
      if (!btn) return;
      if (btn.dataset.busy === 'true') {
        e.preventDefault();
        return;
      }
      btn.dataset.busy = 'true';
      btn.setAttribute('aria-busy', 'true');
    });

    window.addEventListener('pageshow', () => {
      document.querySelectorAll('.cf__button[data-busy]').forEach((btn) => {
        btn.removeAttribute('data-busy');
        btn.removeAttribute('aria-busy');
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-hero-banner"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var query = window.matchMedia('(min-width: 750px)');

    function sync() {
      document.querySelectorAll('.bnr video.bnr__media-d, .bnr video.bnr__media-m').forEach(function (video) {
        if (video.getClientRects().length > 0) {
          video.preload = 'auto';
          var promise = video.play();
          if (promise && promise.catch) {
            promise.catch(function () {});
          }
        } else {
          video.pause();
        }
      });
    }

    query.addEventListener('change', sync);
    document.addEventListener('DOMContentLoaded', sync);
    document.addEventListener('shopify:section:load', sync);
    sync();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-img-with-text"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    var wide = window.matchMedia('(min-width: 750px)');

    function decimals(el) {
      return (el.dataset.count.split('.')[1] || '').length;
    }

    function format(el, value) {
      var places = decimals(el);
      if (el.dataset.separator) {
        return value.toLocaleString('en-US', { minimumFractionDigits: places, maximumFractionDigits: places });
      }
      return value.toFixed(places);
    }

    function resetCount(el) {
      el.textContent = format(el, 0);
    }

    function runCount(el) {
      var target = parseFloat(el.dataset.count);
      var duration = parseInt(el.dataset.duration, 10) || 2000;
      var delay = parseInt(el.dataset.delay, 10) || 0;
      var start = null;

      function step(time) {
        if (start === null) {
          start = time;
        }
        var progress = Math.min((time - start) / duration, 1);
        var eased = 1 - Math.pow(1 - progress, 3);
        el.textContent = format(el, target * eased);
        if (progress < 1) {
          requestAnimationFrame(step);
        }
      }

      setTimeout(function () {
        requestAnimationFrame(step);
      }, delay);
    }

    function init(section) {
      if (section.dataset.ready) {
        return;
      }
      section.dataset.ready = 'true';

      var counters = section.querySelectorAll('[data-count]');
      var animate = !reduce.matches;

      if (animate) {
        counters.forEach(resetCount);
      }

      function reveal() {
        section.classList.add('is-in');
        if (animate) {
          counters.forEach(runCount);
        }
      }

      if (!animate || !('IntersectionObserver' in window)) {
        reveal();
        return;
      }

      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            reveal();
            observer.disconnect();
          }
        });
      }, { threshold: 0.2 });

      observer.observe(section);
    }

    function initAll(root) {
      root.querySelectorAll('.abt').forEach(init);
    }

    function syncVideos() {
      document.querySelectorAll('.abt video.abt__media-d, .abt video.abt__media-m').forEach(function (video) {
        if (video.getClientRects().length > 0) {
          video.preload = 'auto';
          var promise = video.play();
          if (promise && promise.catch) {
            promise.catch(function () {});
          }
        } else {
          video.pause();
        }
      });
    }

    function ready() {
      initAll(document);
      syncVideos();
    }

    wide.addEventListener('change', syncVideos);
    document.addEventListener('DOMContentLoaded', ready);
    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
      syncVideos();
    });
    ready();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["enquiry-form"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('enq-form')) {
    class EnqForm extends HTMLElement {
      connectedCallback() {
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', () => this.init(), { once: true });
        } else {
          this.init();
        }
      }

      disconnectedCallback() {
        if (this.revealer) this.revealer.disconnect();
        clearTimeout(this.busyTimer);
      }

      init() {
        if (this.ready) return;
        this.ready = true;
        this.reveal();
        this.guard();
        this.showMessage();
      }

      reveal() {
        const items = this.querySelectorAll('[data-reveal]');
        if (!items.length) return;
        const stagger = parseInt(this.dataset.stagger, 10) || 0;
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (reduced || !('IntersectionObserver' in window)) {
          items.forEach((item) => item.classList.add('is-visible'));
          return;
        }
        this.revealer = new IntersectionObserver((entries, observer) => {
          let order = 0;
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.style.setProperty('--d', order * stagger + 'ms');
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
            order += 1;
          });
        }, { threshold: 0.15 });
        items.forEach((item) => this.revealer.observe(item));
      }

      guard() {
        const form = this.querySelector('form');
        if (!form) return;
        form.addEventListener('submit', (event) => {
          if (form.dataset.busy) {
            event.preventDefault();
            return;
          }
          form.dataset.busy = 'true';
          this.busyTimer = setTimeout(() => delete form.dataset.busy, 8000);
        });
      }

      showMessage() {
        const message = this.querySelector('.enq__success, .enq__errors');
        if (!message) return;
        message.scrollIntoView({ block: 'center' });
        if (message.hasAttribute('tabindex')) message.focus({ preventScroll: true });
      }
    }

    customElements.define('enq-form', EnqForm);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["facility-tiles"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ftl-tiles')) {
    class FtlTiles extends HTMLElement {
      connectedCallback() {
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', () => this.reveal(), { once: true });
        } else {
          this.reveal();
        }
      }

      disconnectedCallback() {
        if (this.revealer) this.revealer.disconnect();
      }

      reveal() {
        if (this.ready) return;
        this.ready = true;
        const items = this.querySelectorAll('[data-reveal]');
        if (!items.length) return;
        const stagger = parseInt(this.dataset.stagger, 10) || 0;
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (reduced || !('IntersectionObserver' in window)) {
          items.forEach((item) => item.classList.add('is-visible'));
          return;
        }
        this.revealer = new IntersectionObserver((entries, observer) => {
          let order = 0;
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.style.setProperty('--d', order * stagger + 'ms');
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
            order += 1;
          });
        }, { threshold: 0.15 });
        items.forEach((item) => this.revealer.observe(item));
      }
    }

    customElements.define('ftl-tiles', FtlTiles);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["feature-grid"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fgr-grid')) {
    class FgrGrid extends HTMLElement {
      connectedCallback() {
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', () => this.reveal(), { once: true });
        } else {
          this.reveal();
        }
      }

      disconnectedCallback() {
        if (this.revealer) this.revealer.disconnect();
      }

      reveal() {
        if (this.ready) return;
        this.ready = true;
        const items = this.querySelectorAll('[data-reveal]');
        if (!items.length) return;
        const stagger = parseInt(this.dataset.stagger, 10) || 0;
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (reduced || !('IntersectionObserver' in window)) {
          items.forEach((item) => item.classList.add('is-visible'));
          return;
        }
        this.revealer = new IntersectionObserver((entries, observer) => {
          let order = 0;
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.style.setProperty('--d', order * stagger + 'ms');
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
            order += 1;
          });
        }, { threshold: 0.15 });
        items.forEach((item) => this.revealer.observe(item));
      }
    }

    customElements.define('fgr-grid', FgrGrid);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["project-showcase"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('prj-work')) {
    class PrjWork extends HTMLElement {
      connectedCallback() {
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', () => this.reveal(), { once: true });
        } else {
          this.reveal();
        }
      }

      disconnectedCallback() {
        if (this.revealer) this.revealer.disconnect();
      }

      reveal() {
        if (this.ready) return;
        this.ready = true;
        const items = this.querySelectorAll('[data-reveal]');
        if (!items.length) return;
        const stagger = parseInt(this.dataset.stagger, 10) || 0;
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (reduced || !('IntersectionObserver' in window)) {
          items.forEach((item) => item.classList.add('is-visible'));
          return;
        }
        this.revealer = new IntersectionObserver((entries, observer) => {
          let order = 0;
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.style.setProperty('--d', order * stagger + 'ms');
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
            order += 1;
          });
        }, { threshold: 0.15 });
        items.forEach((item) => this.revealer.observe(item));
      }
    }

    customElements.define('prj-work', PrjWork);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["solution-slider"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const reduce = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const init = (root) => {
      const track = root.querySelector('[data-track]');
      const prev = root.querySelector('[data-prev]');
      const next = root.querySelector('[data-next]');
      if (!track) return;

      const cards = () => Array.from(track.children);
      const behavior = () => (reduce() ? 'auto' : 'smooth');
      const isRtl = () => getComputedStyle(track).direction === 'rtl';
      const sign = () => (isRtl() ? -1 : 1);

      const pos = (card) =>
        isRtl() ? card.offsetLeft + card.offsetWidth - track.clientWidth : card.offsetLeft;

      const step = () => {
        const first = track.firstElementChild;
        if (!first) return 0;
        const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        return first.getBoundingClientRect().width + gap;
      };

      const update = () => {
        const max = track.scrollWidth - track.clientWidth;
        const current = Math.abs(track.scrollLeft);
        root.toggleAttribute('data-static', max <= 1);
        if (prev) prev.disabled = current <= 1;
        if (next) next.disabled = current >= max - 1;
      };

      let ticking = false;
      track.addEventListener(
        'scroll',
        () => {
          if (ticking) return;
          ticking = true;
          requestAnimationFrame(() => {
            ticking = false;
            update();
          });
        },
        { passive: true }
      );

      if (prev) prev.addEventListener('click', () => track.scrollBy({ left: -sign() * step(), behavior: behavior() }));
      if (next) next.addEventListener('click', () => track.scrollBy({ left: sign() * step(), behavior: behavior() }));

      if ('ResizeObserver' in window) new ResizeObserver(update).observe(track);
      else window.addEventListener('resize', update);

      let down = false;
      let moved = false;
      let startX = 0;
      let startLeft = 0;

      track.addEventListener('pointerdown', (e) => {
        if (e.pointerType !== 'mouse' || e.button !== 0) return;
        down = true;
        moved = false;
        startX = e.clientX;
        startLeft = track.scrollLeft;
      });

      const cleanup = () => {
        document.removeEventListener('pointermove', onMove);
        document.removeEventListener('pointerup', onUp);
        document.removeEventListener('pointercancel', onUp);
      };

      const onMove = (e) => {
        if (!root.isConnected) return cleanup();
        if (!down) return;
        const dx = e.clientX - startX;
        if (!moved && Math.abs(dx) > 5) {
          moved = true;
          track.classList.add('is-drag');
        }
        if (moved) track.scrollLeft = startLeft - dx;
      };

      const onUp = () => {
        if (!down) return;
        down = false;
        if (!moved) return;
        track.classList.remove('is-drag');
        const left = track.scrollLeft;
        const target = cards().reduce(
          (best, c) => (Math.abs(pos(c) - left) < Math.abs(pos(best) - left) ? c : best),
          track.firstElementChild
        );
        track.scrollTo({ left: pos(target), behavior: behavior() });
      };

      document.addEventListener('pointermove', onMove);
      document.addEventListener('pointerup', onUp);
      document.addEventListener('pointercancel', onUp);

      track.addEventListener(
        'click',
        (e) => {
          if (!moved) return;
          e.preventDefault();
          e.stopPropagation();
          moved = false;
        },
        true
      );

      root.addEventListener('shopify:block:select', (e) => {
        track.scrollTo({ left: pos(e.target), behavior: behavior() });
      });

      update();
    };

    const boot = (scope) => {
      (scope || document).querySelectorAll('[data-ss]:not([data-ready])').forEach((el) => {
        el.dataset.ready = 'true';
        init(el);
      });
    };

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot());
    else boot();

    document.addEventListener('shopify:section:load', (e) => boot(e.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
